;(function () {
  angular
    .module('contrast.get_started')
    .factory('allowedEntityService', allowedEntityServiceFactory)

  function allowedEntityServiceFactory(
    $q,
    ErrorService,
    UserService,
    ApplicationFactory,
    ServerFactory,
    ProfileFactory,
    $routeParams
  ) {
    'ngInject'

    var hasAllowedApplicationCached = undefined
    var hasAllowedServerCached = undefined

    return {
      hasAllowedServerCached: getAllowedServerCached,
      hasAllowedApplicationCached: getAllowedApplicationCached,
      hasAllowedServer: hasAllowedServer,
      hasAllowedApplication: hasAllowedApplication,
      loadAll: loadAll
    }

    function getAllowedServerCached() {
      return hasAllowedServerCached
    }

    function getAllowedApplicationCached() {
      return hasAllowedApplicationCached
    }

    function hasAllowedServer() {
      return loadOrganization().then(function () {
        return loadAllowedServer()
      })
    }

    function hasAllowedApplication() {
      return loadOrganization().then(function () {
        return loadAllowedApplication()
      })
    }

    function loadAll() {
      return loadOrganization().then(function () {
        return $q.all([loadAllowedServer(), loadAllowedApplication()])
      })
    }

    function loadOrganization() {
      if ($routeParams.orgUuid) {
        return ProfileFactory.getOrganization($routeParams.orgUuid).then(
          function (response) {
            var data = response.data.organization
            UserService.setCurrentOrganization(data, { broadcast: false })
          }
        )
      }
    }

    function loadAllowedServer() {
      return ServerFactory.hasActiveServer().then(function (response) {
        hasAllowedServerCached = response.data.has_active_server
        return hasAllowedServerCached
      }, ErrorService.processError)
    }

    function loadAllowedApplication() {
      return ApplicationFactory.countAllowedApps().then(function (response) {
        hasAllowedApplicationCached = response.data.allowed_apps > 0
        return hasAllowedApplicationCached
      }, ErrorService.processError)
    }
  }
})()
